import { SlingoReelMatrixFactory } from "slingo/components/factories/slingo-reel-matrix-factory";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { AlphaDimSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/alpha-dim-symbol-behaviour";
import { AnimateSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";
import { SymbolSubcomponent } from "slotworks/components/matrix/symbol/symbol-subcomponent";

export class FowlReelMatrixFactory extends SlingoReelMatrixFactory {
    protected calculateMinStopDistance(): number {
        return super.calculateMinStopDistance() + 2;
    }

    protected addSymbolBehaviours(matrix: AbstractMatrixComponent<SymbolSubcomponent>): void {
        super.addSymbolBehaviours(matrix);
        matrix.addDefaultSymbolBehaviour((symbol: SymbolSubcomponent) => new AlphaDimSymbolBehaviour(symbol, 0.25));
        matrix.addDefaultSymbolBehaviour((symbol: SymbolSubcomponent) => new AnimateSymbolBehaviour(symbol));
    }
}
